'use client'

import { Header } from './Header'
import { TherapistImpersonation } from './admin/TherapistImpersonation'
import { usePathname } from 'next/navigation'

interface AuthLayoutProps {
  children: React.ReactNode
}

/**
 * AuthLayout - Layout wrapper for the app
 *
 * Server-side authentication model:
 * - Middleware handles auth validation and redirects
 * - No client-side auth checks needed
 * - Simply shows/hides Header based on route
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  const pathname = usePathname()

  // Don't show header on auth pages or MFA pages
  const isAuthPage =
    pathname === '/' ||
    pathname?.includes('/login') ||
    pathname?.includes('/forgot-password') ||
    pathname?.includes('/reset-password') ||
    pathname?.includes('/mfa')

  // Show header when not on auth pages (middleware ensures user is authenticated)
  const shouldShowHeader = !isAuthPage

  return (
    <>
      {shouldShowHeader && <Header />}
      <div className="min-h-screen">
        <main className={shouldShowHeader ? 'pt-0' : ''}>
          {children}
        </main>
      </div>
      {shouldShowHeader && <TherapistImpersonation />}
    </>
  )
}